const WORD_TERMS = [
  "asshole",
  "bastard",
  "bitch",
  "cocksucker",
  "cunt",
  "dickhead",
  "douchebag",
  "fag",
  "faggot",
  "fuck",
  "fucker",
  "jackass",
  "motherfucker",
  "nigga",
  "nigger",
  "pedo",
  "pedophile",
  "rapist",
  "retard",
  "retarded",
  "scumbag",
  "slut",
  "whore",
  "arschloch",
  "bimbo",
  "fick",
  "ficken",
  "fotze",
  "fuehrer",
  "fuhrer",
  "gaskammer",
  "hitler",
  "hure",
  "judensau",
  "judenschwein",
  "kanake",
  "krueppel",
  "neger",
  "nutte",
  "schlampe",
  "schwuchtel",
  "spast",
  "wichser",
  "wixer",
];

const CONTAINS_TERMS = [
  "arschficker",
  "arschgesicht",
  "arschkopf",
  "bastardsohn",
  "childlover",
  "fotzenkind",
  "fotzenkopf",
  "heilhitler",
  "h1tler",
  "hitlersohn",
  "hurensohn",
  "hurentochter",
  "hurenkind",
  "hurenjunge",
  "huansohn",
  "isiskämpfer",
  "kill yourself",
  "killurself",
  "kukluxklan",
  "missgeburt",
  "missgeburtsohn",
  "motherfuker",
  "nazischwein",
  "sieg heil",
  "siegheil",
  "whitepower",
];

export const blockedWords = [...WORD_TERMS, ...CONTAINS_TERMS];

function normalizeBase(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/ß/g, "ss")
    .replace(/æ/g, "ae")
    .replace(/œ/g, "oe")
    .replace(/ø/g, "o")
    .replace(/ł/g, "l");
}

function mapLeet(value) {
  return normalizeBase(value)
    .replace(/0/g, "o")
    .replace(/[1!|]/g, "i")
    .replace(/3/g, "e")
    .replace(/[4@]/g, "a")
    .replace(/[5$]/g, "s")
    .replace(/[7+]/g, "t")
    .replace(/\*/g, "");
}

function collapseRepeated(value) {
  return value.replace(/([\p{L}\p{N}])\1{2,}/gu, "$1$1");
}

function normalizeTokenText(value) {
  return collapseRepeated(mapLeet(value).replace(/[^\p{L}\p{N}]+/gu, " ")).trim();
}

function normalizeCompactText(value) {
  return collapseRepeated(mapLeet(value).replace(/[^\p{L}\p{N}]/gu, ""));
}

export function normalizeModerationText(value) {
  return normalizeCompactText(value);
}

function compactSingleRepeat(value) {
  return normalizeCompactText(value).replace(/([\p{L}\p{N}])\1+/gu, "$1");
}

function hasObfuscation(value) {
  return /[\s_.\-!$@+*|]/.test(String(value || "")) || /[013457]/.test(String(value || ""));
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function matchesSeparatedTerm(value, term) {
  const compactTerm = normalizeCompactText(term);
  if (!compactTerm) return false;

  const mappedText = mapLeet(value);
  const letters = compactTerm.split("").map(escapeRegExp);
  const separator = "[^\\p{L}\\p{N}]+";
  const pattern = `(^|[^\\p{L}\\p{N}])${letters.join(separator)}($|[^\\p{L}\\p{N}])`;
  return new RegExp(pattern, "u").test(mappedText);
}

function matchesWordTerm(value, term) {
  const normalizedText = normalizeTokenText(value);
  const normalizedTerm = normalizeTokenText(term);
  const escaped = escapeRegExp(normalizedTerm);

  if (new RegExp(`(^|\\s)${escaped}(\\s|$)`).test(normalizedText)) {
    return true;
  }

  const compactTerm = normalizeCompactText(term);
  if (!compactTerm) return false;

  const compactText = normalizeCompactText(value);
  if (compactTerm.length >= 5 && compactText.includes(compactTerm)) {
    return true;
  }

  if (hasObfuscation(value) && matchesSeparatedTerm(value, term)) {
    return true;
  }

  return false;
}

function matchesContainsTerm(value, term) {
  const compactTerm = normalizeCompactText(term);
  if (!compactTerm) return false;

  const compactText = normalizeCompactText(value);
  return compactText.includes(compactTerm) || compactSingleRepeat(value).includes(compactSingleRepeat(term));
}

export function getModerationViolation(value) {
  if (!String(value || "").trim()) return null;

  const wordMatch = WORD_TERMS.find((term) => matchesWordTerm(value, term));
  if (wordMatch) {
    return { term: wordMatch, type: "word" };
  }

  const containsMatch = CONTAINS_TERMS.find((term) => matchesContainsTerm(value, term));
  if (containsMatch) {
    return { term: containsMatch, type: "contains" };
  }

  return null;
}

export function isUsernameAllowed(username) {
  return !getModerationViolation(username);
}

export function isTextAllowed(text) {
  return !getModerationViolation(text);
}
